import {
    getStudentsAwardsCertificates,
    getStudentsLessonsCertificates,
} from 'platform-components/src/components/awards/selectors';
import { getCertificatesFromAwards } from 'platform-components/src/components/awards/utils';
import { getHints } from 'platform-components/src/components/user/selectors';
import { createSelector } from 'reselect';

import * as certificatesSelectors from 'common.components/certificates/selectors';
import { getLessonParticipantsResults, getLessonMeta } from 'common.components/lesson/selectors';
import { SUBMITTED_FORMS_HINT } from 'common.components/user/user.constants';

export const getTeacherCertificateFormUrl = createSelector([getLessonMeta], (lessonMeta) => {
    return lessonMeta?.feedback?.teacher?.url || null;
});

export const getShouldShowTeacherCertificateBanner = createSelector([getLessonParticipantsResults], (participants) => {
    return participants.length > 0;
});

export const getCanLoadStudentCertificates = createSelector(
    [certificatesSelectors.getCertificates, getLessonParticipantsResults],
    (certificates, participants): boolean => {
        if (!certificates) {
            return false;
        }

        const files = Object.values(certificates);

        return Boolean(files.length) && files.length === participants.length;
    }
);

export const getTeacherCertificateFormId = createSelector([getTeacherCertificateFormUrl], (formUrl) => {
    if (!formUrl) {
        return false;
    }

    const [, formId] = formUrl.match(/.*forms.yandex.ru.*\/(.*)\//) || [];

    return formId;
});

export const getHasTeacherSubmittedCertificateForm = createSelector(
    [getHints, getTeacherCertificateFormId],
    (viewedHints, formId) => {
        if (!formId) {
            return false;
        }

        return Boolean(viewedHints?.[SUBMITTED_FORMS_HINT]?.[formId]);
    }
);

export const getShouldShowStudentsAwardsBanner = createSelector([getStudentsAwardsCertificates], (awards) =>
    Boolean(awards.length)
);

export const getCanLoadStudentsAwards = createSelector([getStudentsAwardsCertificates], (awards) =>
    awards.every((award) => award?.certificates?.length)
);

export const getAwardsCertificatesByStudentId = createSelector([getStudentsAwardsCertificates], (awards) =>
    getCertificatesFromAwards(awards)
);

export const getShouldShowStudentsCertificatesBanner = createSelector([getStudentsLessonsCertificates], (awards) =>
    Boolean(awards.length)
);

export const getCanLoadStudentsCertificates = createSelector([getStudentsLessonsCertificates], (awards) =>
    awards.every((award) => award?.certificates?.length)
);

export const getLessonsCertificatesByStudentId = createSelector([getStudentsLessonsCertificates], (awards) =>
    getCertificatesFromAwards(awards)
);
